import styled from "styled-components";

export const Container = styled.div`
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  width:100%;
  gap: 10px;
  padding: 20px 10px 0px 0px;
`